import { Component, ViewEncapsulation, OnInit, OnDestroy, QueryList, ViewChildren, AfterViewInit } from '@angular/core';
import * as XLSX from 'xlsx';
import { Router } from '@angular/router';
import { RequestsServices } from '../../../../services/requests.service';
import { UserService } from '../../../../services/user.service';
import { StorageService } from '../../../../services/storage.service';
import { PageBase } from '../../../../page.base';
import { ToasterService } from '../../../../services/toaster.service';
import { ILogUpload } from '../../../../interfaces/company/log_upload';
import { GTMService } from '../../../../services/gtm.service';

const TIMEOUT_TO_CHECK_IMPORT = 60000;

@Component({
  selector: 'app-colabs-import',
  templateUrl: './colabs-import.component.html',
  providers: [ RequestsServices, StorageService, UserService, GTMService],
  encapsulation: ViewEncapsulation.None
})
export class ColabsImportComponent extends PageBase implements OnInit, OnDestroy, AfterViewInit {

  private companyId: string;
  private processedFiles: ILogUpload[];
  public hasLogs = false;
  private browserLanguage: string;

  public isProcessing = false;
  private dataLogs: ILogUpload[];

  @ViewChildren('allTheseThings') things: QueryList<any>;

  private subscriptionOnImportation;

  statusList = {
    finished: 'Finalizado',
    processing: 'Processando',
    received: 'Processando',
    'reverted-hard': 'Revertido (apagado)',
    'reverted-soft': 'Revertido (bloqueado)'
  };

  constructor(
    private toasterService: ToasterService,
    private request: RequestsServices,
    private storage: StorageService,
    private router: Router,
    private userService: UserService,
    private gtmService: GTMService,
  ) {
    super();

    const loggedAccount = this.userService.getLoggedAccount();
    this.companyId = loggedAccount['id'];
    this.getMyLastImportation();
    this.subscribeToImportations();
  }

  public ngOnInit(): void {
    switch (navigator.language) {
      case 'en-US':
          this.browserLanguage = 'en';
          break;
      case 'en':
          this.browserLanguage = 'en';
          break;
      case 'pt-BR':
          this.browserLanguage = 'pt-BR';
          break;
      case 'pt':
          this.browserLanguage = 'pt-BR';
          break;
      default:
          this.browserLanguage = 'pt-BR';
    }
  }

  public ngAfterViewInit() {
    this.things.changes.subscribe(t => {
      this.ngForRendred();
    });
  }

  public ngOnDestroy(): void {
    this.unsubscribeImportations();
  }

  private subscribeToImportations(): void {
    this.subscriptionOnImportation = setInterval(() => {
      this.getMyLastImportation();
    }, TIMEOUT_TO_CHECK_IMPORT);
  }
  private unsubscribeImportations(): void {
    if (this.subscriptionOnImportation) {
      clearInterval(this.subscriptionOnImportation);
    }
  }

  private ngForRendred() {
    this.processedFiles =  this.dataLogs;
  }

  private getMyLastImportation(): void {
    const createParameters = [{
      param: 'companyId',
      value: this.companyId
    }];
    this.request.get({path: 'employeeImports', endPoint: 'importEmployees', params: createParameters})
      .then((imported) => {
      if (imported.result.length === 0) {
          this.hasLogs = false;
          this.unsubscribeImportations();
        } else {
          if (!this.processedFiles) {
            this.processedFiles = imported.result;
          }
          this.dataLogs = this.calculateAndCheck(imported.result);
          this.hasLogs = true;
        }
    }).catch((err) => {
      this.gtmService.error('employee-import-status', err, {});
      if (err.status === 0 || err.status === 500) {
        this.toasterService.info('Oops!',
          'Não conseguimos resgatar a sua importação no momento. Entre em contato conosco e nos avise do problema.', false, 4000);
      }
    });
  }

  private calculateAndCheck(logs: ILogUpload[]): ILogUpload[] {
    this.isProcessing = false;
    let newLogObj: ILogUpload[] = [];
    let newObj: ILogUpload;
    logs.forEach(element => {
      newObj = element;
      newObj.totalProcessed = element.errorCount + element.importedCount;
      newLogObj.push(newObj);
      if (element.status === 'processing' || element.status === 'received') {
        this.isProcessing = true;
      }
    });
    return newLogObj;
  }

  private getErrosArchive(importId: string, fileName: string): void {
    const createParameters = [{
      param: 'employeeImportId',
      value: importId
    }];

    this.request.get({path: 'employeeImports', endPoint: 'erroImport', params: createParameters})
      .then((imported: any) => {
        this.exportAsExcelFile(imported.data, fileName);
    }).catch((err) => {
      this.gtmService.error('employee-import-errors', err, {});
      if (err.status === 0 || err.status === 500) {
        this.toasterService.info('Oops!',
          'Não conseguimos resgatar o arquivo de LOGS no momento. Entre em contato conosco e nos avise do problema.', false, 5000);
      }
    });
  }

  private toExportFileName(excelFileName: string): string {
    return `LOG_ERROS_${excelFileName}`;
  }

  private exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    XLSX.writeFile(workbook, this.toExportFileName(excelFileName));
  }
}
